<!--
 * @Author: zxf
 * @Date: 2022-07-20 18:18:58
 * @LastEditors: zxf
 * @LastEditTime: 2023-07-04 15:25:37
 * @Description: 消防会议内容更新
-->

<template>
  <div
    v-loading="loading"
    class="l-page l-page--detail"
  >
    <!-- 页面头部 Start -->
    <div class="l-page__header c-page__header">
      <!-- 页面标题 -->
      <h2 class="c-page__header-title">
        消防检测会议编辑
      </h2>
      <!-- 标题栏按钮区域 Start -->
      <div class="c-page__header-btns">
        <k-button
          btn-text="保存"
          :auth-type="true"
          type="primary"
          icon="kestrel-icon ki-save"
          @click="handleSave()"
        />
        <k-button
          btn-text="关闭"
          :auth-type="false"
          icon="kestrel-icon ki-close"
          @click="closeNavTabAndTo()"
        />
      </div>
      <!-- 标题栏按钮区域 End -->
    </div>
    <!-- 页面头部 End -->
    <!-- 内容页标题 -->

    <div class="l-page__body l-page--detail__body">
      <hm-page-card class="c-card--detail">
        <el-form
          ref="fd"
          :inline="true"
          label-suffix="："
          :model="fd"
          :rules="fdRules"
          label-position="right"
          label-width="160px"
          class="c-form"
        >
          <el-row class="c-form__row">
            <el-col
              class="c-form__col c-form__part-title"
              :span="24"
            >
              首次会议
            </el-col>
            <el-col
              :span="24"
              class="c-form__col"
            >
              <el-form-item
                class="c-form__item"
                label="项目名称"
                prop="xmmc"
              >
                <el-input
                  v-model="fd.khmc"
                  class="c-form__input"
                  type="text"
                  placeholder="请输入项目名称"
                />
              </el-form-item>
            </el-col>
            <el-col
              :span="12"
              class="c-form__col"
            >
              <el-form-item
                class="c-form__item"
                label="会议标题"
                prop="firsthybt"
              >
                <el-input
                  v-model="fd.firsthybt"
                  class="c-form__input"
                  type="text"
                  placeholder="请输入会议标题"
                />
              </el-form-item>
            </el-col>
            <el-col
              :span="12"
              class="c-form__col"
            >
              <el-form-item
                class="c-form__item"
                label="会议日期"
                prop="firsthyrq"
              >
                <el-date-picker
                  v-model="fd.firsthyrq"
                  value-format="timestamp"
                  placeholder="选择会议日期"
                />
              </el-form-item>
            </el-col>
            <el-col
              :span="24"
              class="c-form__col"
            >
              <el-form-item
                class="c-form__item"
                label="会议内容"
                prop="firsthynr"
              >
                <el-input
                  v-model="fd.firsthynr"
                  class="c-form__input"
                  type="textarea"
                  rows="4"
                  placeholder="请输入会议内容"
                />
              </el-form-item>
            </el-col>
            <el-col
              :span="24"
              class="c-form__col"
            >
              <el-form-item
                class="c-form__item"
                label="签到表"
                prop="htFileId"
              >
                <file-serve-upload
                  ref="htsmjFileUpload"
                  v-model="fd.htFileId"
                  class="u-inline-block"
                  :file-api="$config.ctx.hmfileApi"
                  show-file-list
                  accept="application/pdf,application/msword,.doc,.docx"
                  :data="uploadFd"
                  :max-size="10 * 1024"
                >
                  <k-button
                    btn-text="上传"
                    :auth-type="true"
                    type="primary"
                    icon="kestrel-icon ki-cloud-upload"
                    plain
                  />
                  <span class="u-text-warning">（只能上传一份 doc / docx / pdf 文件，且不超过10M）</span>
                  <k-button
                    btn-text="下载模板"
                    :auth-type="true"
                    type="primary"
                    plain
                  />
                </file-serve-upload>
              </el-form-item>
            </el-col>
            <el-col
              class="c-form__col"
              :span="12"
            >
              <el-form-item
                class="c-form__item"
                label="会议门面照片"
                prop="hymmPhoto"
              >
                <image-upload
                  ref="attrs"
                  v-model="fd.hymmPhoto"
                  multiple-file
                  :file-api="$config.ctx.hmfileApi"
                  show-file-list
                  accept="image/*"
                  :data="uploadFd"
                  list-type="picture-card"
                >
                  <i
                    slot="default"
                    class="el-icon-plus"
                  />
                </image-upload>
              </el-form-item>
            </el-col>
            <el-col
              class="c-form__col"
              :span="12"
            >
              <el-form-item
                class="c-form__item"
                label="会议现场照片"
                prop="hyxcPhoto"
              >
                <image-upload
                  ref="attrs"
                  v-model="fd.hyxcPhoto"
                  multiple-file
                  :file-api="$config.ctx.hmfileApi"
                  show-file-list
                  accept="image/*"
                  :data="uploadFd"
                  list-type="picture-card"
                >
                  <i
                    slot="default"
                    class="el-icon-plus"
                  />
                </image-upload>
              </el-form-item>
            </el-col>
            <el-col
              class="c-form__col"
              :span="12"
            >
              <el-form-item
                class="c-form__item"
                label="人员签到照片"
                prop="ryqdPhoto"
              >
                <image-upload
                  ref="attrs"
                  v-model="fd.ryqdPhoto"
                  multiple-file
                  :file-api="$config.ctx.hmfileApi"
                  show-file-list
                  accept="image/*"
                  :data="uploadFd"
                  list-type="picture-card"
                >
                  <i
                    slot="default"
                    class="el-icon-plus"
                  />
                </image-upload>
              </el-form-item>
            </el-col>
            <el-col
              class="c-form__col"
              :span="12"
            >
              <el-form-item
                class="c-form__item"
                label="会议图片"
                prop="hytp"
              >
                <image-upload
                  ref="attrs"
                  v-model="fd.hytp"
                  multiple-file
                  :file-api="$config.ctx.hmfileApi"
                  show-file-list
                  accept="image/*"
                  :data="uploadFd"
                  list-type="picture-card"
                >
                  <i
                    slot="default"
                    class="el-icon-plus"
                  />
                </image-upload>
              </el-form-item>
            </el-col>

            <el-col
              class="c-form__col c-form__part-title"
              :span="24"
            >
              执业过程
            </el-col>
            <el-col
              :span="24"
              class="c-form__col"
            >
              <el-form-item
                class="c-form__item"
                label="原始记录上传"
                prop="ysjlUpload"
              >
                <file-serve-upload
                  ref="htsmjFileUpload"
                  v-model="fd.ysjlUpload"
                  class="u-inline-block"
                  :file-api="$config.ctx.hmfileApi"
                  show-file-list
                  accept="application/pdf,application/msword,.doc,.docx"
                  :data="uploadFd"
                  :max-size="10 * 1024"
                >
                  <k-button
                    btn-text="附件上传"
                    :auth-type="true"
                    type="primary"
                    icon="kestrel-icon ki-cloud-upload"
                    plain
                  /><br>
                  <span class="u-text-warning">（请上传pdf文件）</span>
                </file-serve-upload>
              </el-form-item>
            </el-col>

            <el-col
              class="c-form__col c-form__part-title"
              :span="24"
            >
              末次会议
            </el-col>
            <el-col
              :span="12"
              class="c-form__col"
            >
              <el-form-item
                class="c-form__item"
                label="会议标题"
                prop="lasthybt"
              >
                <el-input
                  v-model="fd.lasthybt"
                  class="c-form__input"
                  type="text"
                  placeholder="请输入会议标题"
                />
              </el-form-item>
            </el-col>
            <el-col
              :span="12"
              class="c-form__col"
            >
              <el-form-item
                class="c-form__item"
                label="会议日期"
                prop="lasthyrq"
              >
                <el-date-picker
                  v-model="fd.lasthyrq"
                  value-format="timestamp"
                  placeholder="选择会议日期"
                />
              </el-form-item>
            </el-col>
            <el-col
              :span="24"
              class="c-form__col"
            >
              <el-form-item
                class="c-form__item"
                label="会议内容"
                prop="lasthynr"
              >
                <el-input
                  v-model="fd.lasthynr"
                  class="c-form__input"
                  type="textarea"
                  rows="4"
                  placeholder="请输入会议内容"
                />
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </hm-page-card>
    </div>
  </div>
</template>
<script>
import { hyglService } from './hygl.service';
/* import JcjlDialog from './jcjlDialog.vue';
import JcjzwDialog from './jzw/listDialog.vue'; */
import config from '@/config.js';

export default ({
  name: 'EditHygl',
  /* components: {
    JcjlDialog,
    JcjzwDialog
  }, */
  props: {
    dlParams: {
      type: Object,
      default: function () {
        return {};
      }
    }
  },
  data () {
    return {
      loading: false, // 页面loading状态
      xmId: '', // 数据ID
      xmStatus: null, // 项目状态
      jcxStatus: null, // 检测项状态

      /* 弹窗 Start */
      showDialogName: '',
      dialogParams: {},
      /* 弹窗 End */

      /* 申请信息 Start */
      jcnrXtList: null,
      fd: {
        xmmc: null,
        hybt: null,
        firsthyrq: null,
        lasthyrq: null,
        firsthynr: null,
        lasthynr: null,
        firsthybt: null,
        htFileId: null,
        hymmPhoto: [],
        hyxcPhoto: [],
        ryqdPhoto: [],
        hytp: [],
        xcjcyDm: null

      },
      /* 申请信息 End */

      /** 表单验证规则 Start */
      fdRules: {

        xmmc: [
          this.$validUtils.required('项目名称'),
          this.$HMValidator.maxLength('项目名称', 300)
        ],
        firsthybt: [
          this.$validUtils.required('会议标题')
        ],
        lasthybt: [
          this.$validUtils.required('会议标题')
        ],
        firsthyrq: [
          this.$validUtils.required('会议日期')
        ],
        lasthyrq: [
          this.$validUtils.required('会议日期')
        ],
        htFileId: [
          this.$validUtils.required('签到表')
        ],
        firsthynr: [
          this.$validUtils.required('会议内容')
        ],
        lasthynr: [
          this.$validUtils.required('会议内容')
        ],
        hymmPhoto: [
          this.$HMValidator.required('会议门面照片')
        ],
        hyxcPhoto: [
          this.$HMValidator.required('会议现场照片')
        ],
        ryqdPhoto: [
          this.$HMValidator.required('人员签到照片')
        ],
        hytp: [
          this.$HMValidator.required('会议图片')
        ],
        ysjlUpload: [
          this.$HMValidator.required('原始记录上传')
        ]

      },
      /** 表单验证规则 End */

      /* 文件服务器对接参数 Start */
      headers: { // 请求头部配置
        [config.serverHeaderTokenName]: this.$HMCookies.get(config.serverHeaderTokenName)
      },
      prepareUrl: config.prepareUrl, // 上传预加载服务地址
      uploadUrl: config.uploadUrl, // 上传服务地址
      uploadFd: { // 上传服务入参
        meta: [
          {
            key: 'htwj',
            value: null
          }
        ]
      }
      /* 文件服务器对接参数 END */
    };
  },
  methods: {
    /**
     * @description: 通用显示模态框dialog组件
     * @param {String} _name 显示的模态框dialog名称
     * @param {Object} _params 模态框dialog传入参数
     * @return {*}
     */
    handleDialog (_name, _params) {
      this.showDialogName = _name;
      this.dialogParams = _params;
    },
    /**
     * 获取检测项状态
     */
    getJcxStatus () {
      hyglService.getJcxStatus(this.xmId)
        .then(rsp => {
          this.jcxStatus = rsp.data.data;
        })
        .catch(err => {
          console.error('获取检测会议内容失败！', err);
        });
    },
    /**
     * 获取检测项状态
     */
    getXtJcnrList () {
      hyglService.getXtJcnrList()
        .then(rsp => {
          this.jcnrXtList = rsp.data;
        })
        .catch(err => {
          console.error('获取消防检测会议内容信息失败！', err);
        });
    },
    /**
     * 获取检测项状态
     */
    getXmStatus () {
      hyglService.getStatus(this.xmId)
        .then(rsp => {
          this.jcxStatus = rsp.data.data;
        })
        .catch(err => {
          console.error('获取检测会议状态失败！', err);
        });
    },
    /**
     * @description: 界面初始化
     * @return {*}
     */
    async init () {
      /** 按钮控制显示 */
      // await this.getXmStatus();
      // await this.getJcxStatus();
      this.loading = true;
      // 编辑模式初始化
      await hyglService.getInfo(this.xmId)
        .then(rsp => {
          this.fd = Object.assign({}, this.fd, rsp.data);
          this.fd.jcnrList = [];
          rsp.data.jcnrList.forEach(e => {
            this.fd.jcnrList.push(e.jcnrId);
          });
          this.fd.xcjcyDm = [];
          rsp.data.xcjcyDm.forEach(e => {
            this.fd.xcjcyDm.push(e.cyId);
          });
        })
        .catch(err => {
          console.error('获取消防检测会议信息失败！', err);
        }).finally(() => {
          this.loading = false;
        });
    },

    /**
     * @description: 表单数据封装处理
     * @return {*}
     */
    handleFormData () {
      const _this = this;
      // _this.fd.xcjcyDm = _this.fd.xcjcyDm ? _this.fd.xcjcyDm.join(',') : '';
      // _this.fd.jcnrDm = _this.fd.jcnrDm ? _this.fd.jcnrDm.join(',') : '';
      [_this.fd.jcrqq, _this.fd.jcrqz] = _this.fd.jcrqQZ;
    },
    /**
     * @description: 消防检测项目保存
     * @return {*}
     * @param {*} p
     */
    handleSave () {
      const _this = this;
      _this.$refs.fd.validate((valid) => {
        if (valid) {
          _this.loading = true;
          _this.handleFormData();
          hyglService.update(_this.fd)
            .then(rsp => {
              _this.$alert('编辑成功！', '提示', {
                confirmButtonText: '确定',
                type: 'success',
                callback: action => {
                  this.closeNavTabAndTo({ name: 'hyglIndex', params: { isRefresh: true } }, true);
                }
              });
            })
            .catch(err => {
              console.error('消防检测会议编辑出错！', err);
            })
            .finally(() => {
              _this.loading = false;
            });
        }
      });
    }
  },
  watch: {

  },
  created () {
  // 获取路由的数据ID
    this.xmId = this.$route.params.xmId;
    console.log(this.xmId);
    this.init();
    this.getXtJcnrList();
  }
});
</script>
